module.exports = __webpack_public_path__ + "static/media/webpack.c500a380.png";